import { TMessageSchema, TMessagesMap } from '../../types/messages';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum ESendMessageActionTypes {
  SetFailed = 'sendMessage/failed',
  SetSuccess = 'sendMessage/success',
  SetPending = 'sendMessage/pending',
  DeleteMessageFromChat = 'sendMessage/deleteFromChat',
  MarkMessageAsDeleted = 'sendMessage/markAsDeleted',
  RestoreMessage = 'sendMessage/restoreMessage',
  SetFirstMessageSuccess = 'sendMessage/firstMessageSuccess',
}

export interface ISendMessagePayload {
  message: TMessageSchema;
  messageId: string;
  messagesMap: TMessagesMap;
}

export interface IDeleteMessagePayload {
  chatId: string;
  messageId: string;
  messagesMap: TMessagesMap;
}

export interface IMarkMessageAsDeletedPayload {
  message: TMessageSchema;
  messagesMap: TMessagesMap;
  shouldDecreaseUnread?: boolean;
}

export interface IRestoreMessagePayload {
  message: TMessageSchema;
  messageId: string;
  messagesMap: TMessagesMap;
  shouldIncreaseUnread?: boolean;
}

export interface ISendFirstMessagePayload {
  message: TMessageSchema;
  messagesMap: TMessagesMap;
}

export type TSendMessageActions =
  | ITypedReduxAction<ESendMessageActionTypes.SetFailed, ISendMessagePayload>
  | ITypedReduxAction<ESendMessageActionTypes.SetSuccess, ISendMessagePayload>
  | ITypedReduxAction<ESendMessageActionTypes.SetPending, ISendMessagePayload>
  | ITypedReduxAction<ESendMessageActionTypes.DeleteMessageFromChat, IDeleteMessagePayload>
  | ITypedReduxAction<ESendMessageActionTypes.MarkMessageAsDeleted, IMarkMessageAsDeletedPayload>
  | ITypedReduxAction<ESendMessageActionTypes.RestoreMessage, IRestoreMessagePayload>
  | ITypedReduxAction<ESendMessageActionTypes.SetFirstMessageSuccess, ISendFirstMessagePayload>;
